import { useMsal } from "@azure/msal-react";
import { enviroment } from "../enviroment";

/**
 * True only for the named admins allowed to manage API keys + see vendor revenue.
 * The allowlist lives in REACT_APP_API_KEYS_ADMIN_EMAILS (comma-separated).
 *
 * Reads the email from MSAL idTokenClaims (B2C populates `emails`) and falls
 * back to `username` for non-B2C tenants.
 */
export function useIsApiKeyAdmin(): boolean {
  const { accounts } = useMsal();
  const account = accounts[0];
  if (!account) return false;
  if (enviroment.apiKeysAdminEmails.length === 0) return false;

  const candidates = collectEmails(account);
  return candidates.some((c) => enviroment.apiKeysAdminEmails.includes(c));
}

// Every e-mail candidate of an MSAL account, lower-cased. Shared with the
// Clarity identity hook (internal-domain check) - read only in the
// browser to a boolean; the value never leaves the client.
export function collectEmails(account: {
  username?: string;
  idTokenClaims?: Record<string, unknown>;
}): string[] {
  const out: string[] = [];
  const claims = account.idTokenClaims ?? {};

  const emailsClaim = claims["emails"];
  if (Array.isArray(emailsClaim)) {
    for (const e of emailsClaim) {
      if (typeof e === "string") out.push(e.trim().toLowerCase());
    }
  }

  const singleEmail = claims["email"];
  if (typeof singleEmail === "string") out.push(singleEmail.trim().toLowerCase());

  const preferred = claims["preferred_username"];
  if (typeof preferred === "string") out.push(preferred.trim().toLowerCase());

  if (account.username) out.push(account.username.trim().toLowerCase());

  return out.filter(Boolean);
}
